import { Fragment } from 'react';
import { Field, Form, Formik } from 'formik';
import Segment from '../shared/segment';
import Divider from '../shared/divider';
import Alert from '../shared/alert';
import Button from '../shared/buttons/button';
import FormInput from '../shared/forms/input';
import { password } from '../shared/forms/validations';
import { useFormErrorMessage } from '../../hooks/index/use-form-error-message';
import { APIErrorType } from '../../api';
import { FormikValues } from 'formik/dist/types';

export type PasswordFormPropsType = {
  onSubmit: (password: string) => Promise<void>;
};

function PasswordForm({ onSubmit }: PasswordFormPropsType) {
  const { formErrorMessage, setFormErrorMessage, resetFormErrorMessage } = useFormErrorMessage();

  async function submit({ password }: { password: string }) {
    try {
      await onSubmit(password);
    } catch (error) {
      const errorMessage = (error as APIErrorType).data.detail || 'تغییر رمز عبور انجام نشد.';
      setFormErrorMessage(errorMessage);
    }
  }

  function validate(values: FormikValues) {
    if (values.password !== values.password2) return { password2: 'رمزهای عبور غیر یکسان هستند.' };
    return {};
  }

  return (
    <Segment>
      <Divider content='فرم تغییر رمز عبور' className='mb-5' />

      <Formik initialValues={{ password: '', password2: '' }} onSubmit={submit} validate={validate}>
        {({ dirty, isSubmitting }) => (
          <Fragment>
            {dirty && formErrorMessage && (
              <Alert content={formErrorMessage} className='mt-3 mb-5' />
            )}

            <Form onChange={resetFormErrorMessage}>
              <Field
                required
                name='password'
                type='password'
                label='رمز عبور جدید'
                component={FormInput}
                validate={password}
                className='my-4'
              />
              <Field
                required
                name='password2'
                type='password'
                label='تکرار رمز عبور جدید'
                placeholder='رمز عبور جدید خود را مجدد وارد نمایید'
                component={FormInput}
                validate={password}
              />
              <Button
                type='submit'
                disabled={!dirty || isSubmitting}
                content='تغییر رمز عبور'
                className='my-2 mr-auto'
              />
            </Form>
          </Fragment>
        )}
      </Formik>
    </Segment>
  );
}

export default PasswordForm;
